import React, { useEffect } from 'react';
import { useNavigate }      from 'react-router-dom';
import Header               from '../../components/header';
import axios from 'axios';

const instructions = [
  'Click on “Connect with John Deere”.',
  'Sign in with your John Deere account.',
  'Grant the requested permissions.',
  'Return to this portal and see your data.',
];

const Home = () => {
  const nav = useNavigate();

  useEffect(() => {
    const jdOrgId = localStorage.getItem('jd_organization_id');
    const token   = localStorage.getItem('origo_access_token');
    if (jdOrgId && token) nav('/choose-data');
    else if(localStorage.getItem('origo_auth_url') && !localStorage.getItem('disconnected')){
      handleAuthorization();
    }
  }, [nav]);

  const handleAuthorization = async () => {
    try {
      // if (login.organizationExists) {
        // ✅ Call /authorize for user
        const username = localStorage.getItem('origo_username');
        const password = localStorage.getItem('origo_password');
        const authRes = await axios.post(
          `${process.env.REACT_APP_ORIGO_BASE_URL}oauth-jd/authorize`,
          { username, password, isAdmin: false }
        );

        const auth = authRes?.data?.data || {};
        const access_token = auth.access_token;
        const organization_id = auth.organization_id;
        const jd_organization_id = auth.jd_organization_id;

        if (!access_token || !organization_id) {
          throw new Error('Authorization failed – missing token or organization ID');
        }

        localStorage.setItem('origo_access_token', access_token);
        localStorage.setItem('origo_org_id', organization_id.toString());
        localStorage.setItem('jd_organization_id', jd_organization_id ?? '');

        nav('/choose-data');
        return;
      // }
    } catch (err) {
      console.error('Authorization check failed:', err);
    }
  };

const handleConnectClick = () => {
  const authUrl = localStorage.getItem('origo_auth_url');
  localStorage.removeItem('disconnected');
  if (authUrl) {
    // ✅ Redirect to John Deere OAuth login
    window.location.href = authUrl;
  } else {
    alert('Authorization URL not found. Please try logging in again.');
  }
};


  const disabled = !localStorage.getItem('origo_auth_url');

  return (
    <div className="min-h-screen px-4 py-6 bg-gray-100 dark:bg-gray-900 text-black dark:text-white">
      <Header />
  
      {/* instructions */}
      <div className="bg-white dark:bg-gray-800 rounded shadow-sm p-6 mx-4">
        <h3 className="text-lg font-semibold mb-4">Instructions</h3>
        <div className="space-y-4">
          {instructions.map((t) => (
            <div key={t} className="flex items-start gap-2 text-xs text-gray-800 dark:text-gray-300">
              <span className="inline-block mt-1 text-blue-600 dark:text-blue-400">✓</span>
              {t}
            </div>
          ))}
        </div>
      </div>
  
      {/* connect */}
      <div className="text-center mt-12">
        <button
          onClick={handleConnectClick}
          disabled={disabled}
          className={`inline-flex items-center gap-3 px-6 py-3 rounded-full shadow font-semibold text-lg transition
            ${
              disabled
                ? 'bg-gray-300 text-white cursor-not-allowed dark:bg-gray-700 dark:text-gray-400'
                : 'bg-white text-blue-600 border border-blue-600 hover:bg-blue-600 hover:text-white dark:bg-gray-800 dark:text-blue-400 dark:border-blue-400 dark:hover:bg-blue-500 dark:hover:text-white'
            }`}
        >
          Connect with <img src="/images/JD-logo.png" alt="JD" className="h-6" />
        </button>
      </div>
    </div>
  );
  
};

export default Home;
